@if (showIcon()) {
  <rask-icon icon="fas fa-map-marker-alt" popoverContainer="body"
    popoverClass="drivningspunkter-validering" class="drivningspunkter-main-icon"
    [ngClass]="allValid() ? 'valid' : 'invalid'">
    <div class="body">
      <h3 class="popover-header">{{texts.header}}</h3>
      <div class="drivningspunkter">
        <div>
          <span [ngClass]="isLarmkoordinatValid() ? 'valid' : 'invalid'"
            class="fa-stack fa-1x drivningspunkt">
            <i class="fas fa-circle fa-stack-2x"></i>
            @if (isLarmkoordinatValid()) {
              <i class="fas fa-check fa-stack-1x fa-inverse"></i>
            }
          </span>
          <div class="drivningspunkt-text">{{texts.larmkoordinat}}</div>
        </div>
        <div>
          <span [ngClass]="isKojplatsValid() ? 'valid' : 'invalid'"
            class="fa-stack fa-1x drivningspunkt">
            <i class="fas fa-circle fa-stack-2x"></i>
            @if (isKojplatsValid()) {
              <i class="fas fa-check fa-stack-1x fa-inverse"></i>
            }
          </span>
          <div class="drivningspunkt-text">{{texts.kojplats}}</div>
        </div>
        <div>
          <span [ngClass]="isAvlaggValid() ? 'valid' : 'invalid'" class="fa-stack fa-1x drivningspunkt">
            <i class="fas fa-circle fa-stack-2x"></i>
            @if (isAvlaggValid()) {
              <i class="fas fa-check fa-stack-1x fa-inverse"></i>
            }
          </span>
          <div class="drivningspunkt-text">{{texts.avlagg}}</div>
        </div>
      </div>
    </div>
  </rask-icon>
}